import {combineReducers} from 'redux';
import ListOrder from './ListOrder/reducer';
import DistributeOrder from './DistributeOrder/reducer';

export default combineReducers({
    ListOrder,
    DistributeOrder,
});